import {FC} from 'react'
import { useWeb3Context } from '../../hooks'
import { DEFAULT_NETWORK } from '../constants'
interface ConnectMenuProps {
  styleParam: string
}

const ConnectMenu: FC<ConnectMenuProps> = ({styleParam}) => {
  const { connect, connected, providerChainID, checkWrongNetwork } =
    useWeb3Context()

  let buttonText = 'Connect Wallet'
  let clickFunc = () => {
    try {
      connect()      
    } catch (e) {
      return;
    }
  }
  let buttonStyle = {}

  if (connected && providerChainID !== DEFAULT_NETWORK) {
    buttonText = 'Wrong network'
    buttonStyle = { backgroundColor: 'rgb(255, 67, 67)' }
    clickFunc = () => {
      checkWrongNetwork()
    }
  }

  return (
    <>
      <button
        className={styleParam}
        type='button'
        style={buttonStyle}
        onClick={clickFunc}
      >
        <span>{buttonText}</span>
        {/* pendingTransactions.length > 0 && (
                <div className="connect-button-progress">
                    <CircularProgress size={15} color="inherit" />
                </div>
            ) */}
      </button>
    </>
  )
}

export default ConnectMenu
